import { render, staticRenderFns } from "./EditableHeader.vue?vue&type=template&id=f8033222&scoped=true"
import script from "./EditableHeader.vue?vue&type=script&lang=js"
export * from "./EditableHeader.vue?vue&type=script&lang=js"
import style0 from "./EditableHeader.vue?vue&type=style&index=0&id=f8033222&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8033222",
  null
  
)

export default component.exports